export default __webpack_public_path__ + "static/binance@2x-3aaac03f75319e20673bfc232d87c62c.png";